var map = {
	"./main/alerts/alerts.module": [
		"./src/app/main/alerts/alerts.module.ts",
		"main-alerts-alerts-module"
	],
	"./main/app-rewards/app-rewards.module": [
		"./src/app/main/app-rewards/app-rewards.module.ts",
		"default~main-app-rewards-app-rewards-module~main-user-pages-user-pages-module",
		"common",
		"main-app-rewards-app-rewards-module"
	],
	"./main/certificate/certificate.module": [
		"./src/app/main/certificate/certificate.module.ts",
		"common",
		"main-certificate-certificate-module"
	],
	"./main/dashboard/project/project.module": [
		"./src/app/main/dashboard/project/project.module.ts",
		"main-dashboard-project-project-module"
	],
	"./main/feedback/feedback.module": [
		"./src/app/main/feedback/feedback.module.ts",
		"common",
		"main-feedback-feedback-module"
	],
	"./main/group-manage/group-manage.module": [
		"./src/app/main/group-manage/group-manage.module.ts",
		"common",
		"main-group-manage-group-manage-module"
	],
	"./main/master-settings/master-settings.module": [
		"./src/app/main/master-settings/master-settings.module.ts",
		"common",
		"main-master-settings-master-settings-module"
	],
	"./main/merchandise-store/merchandise-store.module": [
		"./src/app/main/merchandise-store/merchandise-store.module.ts",
		"common",
		"main-merchandise-store-merchandise-store-module"
	],
	"./main/moderator-manage/moderator-manage.module": [
		"./src/app/main/moderator-manage/moderator-manage.module.ts",
		"common",
		"main-moderator-manage-moderator-manage-module"
	],
	"./main/moderator-request/moderator-request.module": [
		"./src/app/main/moderator-request/moderator-request.module.ts",
		"common",
		"main-moderator-request-moderator-request-module"
	],
	"./main/notifications/notifications.module": [
		"./src/app/main/notifications/notifications.module.ts",
		"default~main-notifications-notifications-module~main-settings-settings-module",
		"main-notifications-notifications-module"
	],
	"./main/pages/pages.module": [
		"./src/app/main/pages/pages.module.ts",
		"main-pages-pages-module"
	],
	"./main/plants-added-by-user/plants-added-by-user.module": [
		"./src/app/main/plants-added-by-user/plants-added-by-user.module.ts",
		"main-plants-added-by-user-plants-added-by-user-module"
	],
	"./main/preview/preview.module": [
		"./src/app/main/preview/preview.module.ts",
		"main-preview-preview-module"
	],
	"./main/product-category/product-category.module": [
		"./src/app/main/product-category/product-category.module.ts",
		"common",
		"main-product-category-product-category-module"
	],
	"./main/reported-users/reported-users.module": [
		"./src/app/main/reported-users/reported-users.module.ts",
		"main-reported-users-reported-users-module"
	],
	"./main/reward-activities/reward-activities.module": [
		"./src/app/main/reward-activities/reward-activities.module.ts",
		"common",
		"main-reward-activities-reward-activities-module"
	],
	"./main/settings/settings.module": [
		"./src/app/main/settings/settings.module.ts",
		"default~main-notifications-notifications-module~main-settings-settings-module",
		"main-settings-settings-module"
	],
	"./main/terms-conditions/terms-conditions.module": [
		"./src/app/main/terms-conditions/terms-conditions.module.ts",
		"main-terms-conditions-terms-conditions-module"
	],
	"./main/user-manage/user-manage.module": [
		"./src/app/main/user-manage/user-manage.module.ts",
		"common",
		"main-user-manage-user-manage-module"
	],
	"./main/user-pages/user-pages.module": [
		"./src/app/main/user-pages/user-pages.module.ts",
		"default~main-app-rewards-app-rewards-module~main-user-pages-user-pages-module",
		"main-user-pages-user-pages-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;